import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import classNames from "classnames";
import SignupForm from "./SignupForm";

//images
import fb from "../../../../../assets/images/redesign/signup-react/facebook.svg";
// import google from "../../../../../assets/images/redesign/signup-react/google.png";

function Login({ close, isSecondVersion, isLogin, setIsLogin }) {
  const login = isLogin;
  const setLogin = setIsLogin;

  const styles = classNames("pw-login-container", {
    "pw-login-container-second": isSecondVersion
  });

  return (
    <div className={styles}>
      <h1 className="pw-login-container--header">
        {login ? "Log In" : "Sign Up"}
      </h1>
      <div>
        {isSecondVersion ? null : (
          <FontAwesomeIcon
            onClick={close}
            className="pw-login-cross-icon"
            icon={"times"}
          />
        )}
      </div>
      <div className="pw-login-container--social-container">
        {/*<div className="pw-login-container--social-container__block-google">*/}
        {/*  <img src={google} alt="" />*/}
        {/*  <span>Sign up with Google</span>*/}
        {/*</div>*/}
        <a
          href={"/auth/facebook"}
          className="pw-login-container--social-container__block-fb"
        >
          <img src={fb} alt="" />
          <span>Connect with Facebook</span>
        </a>
      </div>

      <p className="pw-login-container--subtitle">
        We’ll never post on your behalf without your permission
      </p>

      <div className="pw-login-container--or-container">
        <div className="pw-login-container--or-item" />
        <p className="pw-login-container--subtitle-or">OR</p>
        <div className="pw-login-container--or-item" />
      </div>
      <SignupForm
        login={login}
        setLogin={setLogin}
        closeable={isSecondVersion}
      />
    </div>
  );
}

export default Login;

Login.propTypes = {
  close: PropTypes.func,
  isSecondVersion: PropTypes.bool,
  isLogin: PropTypes.bool,
  setIsLogin: PropTypes.func
};
